import React, {useMemo} from 'react';
import styled, {css} from 'styled-components';
import AnimateHeight from 'react-animate-height';

import Icon from 'components/icons/icon';

import useBreakpoints from 'hooks/useBreakpoints';

import theme, {bp, color} from 'settings/theme';


type Props = {
  name: string,
  title?: string,
  logoUrl?: string,
  isOpen: boolean
  togglePanel: (name: string) => void,
  children?: React.ReactNode
};

type StyledProps = {
  isOpen: boolean
};

// Product Header
const Component: React.FC<Props> = (props) => {

  const currentBreakpoint: any = useBreakpoints();

  const isOpen = useMemo(() => props.isOpen || currentBreakpoint.size > 2, [props.isOpen, currentBreakpoint.size]);

  const handleTitleClick = () => {
    props.togglePanel(props.name)
  };

  return (
    <StyledComponent isOpen={isOpen} className="productPriceBox">

      <button className="productPriceBox-button" onClick={handleTitleClick}>
        <div className="productPriceBox-top">
          <div className="productPriceBox-top-title">
            {props.title && <span>{props.title}</span>}
            {props.logoUrl && <img src={props.logoUrl} className="productPriceBox-top-logo" />}
          </div>
          <div className="productPriceBox-top-arrow">
            <Icon iconName="chevron" iconDirection="down" />
          </div>
        </div>
      </button>

      <AnimateHeight
        duration={ 150 }
        height={isOpen ? 'auto' : 0}
      >
        <div className="productPriceBox-panel">
          {props.children}
        </div>
      </AnimateHeight>

    </StyledComponent>
  );

}


export default Component;




// Styles
const StyledComponent = styled.div<StyledProps>`

  display: block;
  width: 100%;
  min-height: 100%;
  border-top: solid 1px ${color.lines};
  
  .productPriceBox-button{
    display: flex;
    width: 100%;
    height: 100%;
  }

  .productPriceBox-top{
    display: flex;
    align-items: stretch;
    width: 100%;
    height: 50px;
    border-bottom: solid 1px ${color.lines};
    background-color: white;
  }

  .productPriceBox-panel{
    border-bottom: solid 1px ${color.lines};
    background-color: white;
  }

  .productPriceBox-top-title{
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    padding-left: 24px;
    color: ${color.grey(40)};
    font-family: ${theme.typography.fontFamilySecondary};
    font-size: 18px;
    font-weight: bold;
  }

  .productPriceBox-top-logo{
    height: 24px;
  }

  .productPriceBox-top-arrow{

    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 50px;
    height: 50px;

    button{
      width: 100%;
      height: 100%;
    }

    .icon{

      width: 15px;
      height: 15px;
      transform: ${props => props.isOpen ? `rotate(0deg)` : `rotate(-90deg)`};
      transition: all 0.15s ease-out;

      svg{
        fill: ${color.grey(40)}
      }

    }

    button:hover, button:focus {
      .icon svg{fill: ${color.grey(60)}}
    }

  }


  @media (min-width: ${bp(3)}) {

    .productPriceBox-top{
      border-left: solid 1px ${color.lines};
      border-right: solid 1px ${color.lines};
    }

    .productPriceBox-top-arrow{
      display: none;
    }

    .productPriceBox-panel{
      border-left: solid 1px ${color.lines};
      border-right: solid 1px ${color.lines};
    }

  }

  @media (min-width: ${bp(4)}) {

    .productPriceBox-top{
      height: 60px;
    }

    .productPriceBox-top-logo{
      height: 30px;
    }

    .productPriceBox-top-arrow{
      width: 60px;
      height: 56px;
    }

  }

`;



